/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI75534ReqTaskModelsItem {
  
  /** 任务名称 */
  taskName?: string;
  
  /** 任务活动 */
  taskActivity?: string;
  
  /** 任务负责人 */
  taskOwner?: string;
  
  /** 任务序号 */
  taskNum?: string;
  
};
    
  



export interface API75534Req {
  
  /** TaskModel */
  taskModels?: IAPI75534ReqTaskModelsItem[];
};



export type API75534Res = {};


// 接口函数 75534 保存模型

export interface IUsePostAPI75534Return {
  /** 保存模型: 接口请求状态 */
  isAPI75534Loading: boolean;
  /** 保存模型: 接口请求返回数据 */
  dataAPI75534: API75534Res;
  /**  保存模型: 接口数据请求方法 */
  fetchAPI75534Data: (inputs: API75534Req, config?: YWRequestConfig) => Promise<API75534Res>;
  /** 保存模型: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75534 = ():IUsePostAPI75534Return => {
  let isMount = true;
  const [isAPI75534Loading, setIsAPI75534Loading] = useState(false);
  const [dataAPI75534, setDataAPI75534] = useState<API75534Res>({} as API75534Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/edit`;

  const fetchAPI75534Data = async (inputs: API75534Req, config?: YWRequestConfig): Promise<API75534Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75534Req>) || {}) as API75534Req;
    
  
    if ( isMount ) {
      setIsAPI75534Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75534Res>(`${basePath}/yoaichat-web/chat/task/model/edit`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75534(res || {} as API75534Res);
        setIsAPI75534Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75534Loading(false);
      }
      return false as unknown as API75534Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75534Loading,
    dataAPI75534,
    fetchAPI75534Data,
    requestUrl,
  }
}

